
import axiosFetch from "../Axios"
import { useAuth } from "../hooks/useAuth";

// const apiCall = async ({endpoint,method="GET",data=null,isMultipart=false})=>{
//     try{
//         const response = await axiosFetch(endpoint,method,data,isMultipart)
//         return {data:response.data,error:null}
//     }catch(error){
//         console.error(`API Error on ${method} ${endpoint}: `,error)
//         throw {data:null,error:error}
//     }
// }

// export default apiCall

const apiCall = async ({ method, endpoint,token=null, data=null, isMultipart = false,body=null,headers }) => {

    
    try {
      const config = {
        method:method.toUpperCase(),
        url: endpoint,
        headers:headers,
      };

      if (config.method === 'GET' && data) {
        config.params = data;
      } else if (data) {
        config.data = data;
      }
      
      // config.headers = {
      //   ...(headers || {}),
      // };

      if (isMultipart===true) {
        config.headers["Content-Type"] = "multipart/form-data";
      }

      if(body){
        console.log(body)
        config.body = body
      }

      if(token){
        config.headers={
          ...config.headers,
          "Authorization":`Bearer ${token}`
          }
      }

      if(headers){
        config.headers={
          ...config.headers,
          ...(headers || {})
        }
      }
  
      const response = await axiosFetch().request(config);
      return response;
    } catch (error) {
        console.error(`API Error on ${method} ${endpoint}: `,error)
        // throw {data:null,error:error}
        return error
    }
  };
  
  export default apiCall;